import { useQuery } from "@tanstack/react-query";
import { NotificationService } from "@/services/notification/notificationService";
import { useAuth } from "@/hooks/useAuth";

export const useHasUnreadNotifications = () => {
  const { user } = useAuth();
  const userId = String(user?.id || "");

  const query = useQuery({
    queryKey: ["hasUnreadNotifications", userId],
    queryFn: () => NotificationService.hasUnreadNotifications(userId),
    enabled: !!userId,
    staleTime: 30 * 1000,
    gcTime: 60 * 1000,
    refetchInterval: 30 * 1000,
  });

  return {
    hasUnreadNotifications: query.data ?? false,
    hasUnreadData: query.data,
    isLoadingHasUnread: query.isLoading,
    hasUnreadError: query.error,
    refetchHasUnread: query.refetch,
  };
};
